<template>
  <div class="row">
    <div class="col-md-6">
      <label>{{datos.name}} ({{this.datos.importe}} €)</label>
      <input
        class="text-right mi-input"
        type="number"
        step="1"
        min="0"
        :max="datos.unidades"
        v-model="concepto.cantidad"
        @change="emitirConcepto"
      />
    </div>
    <div class="col-md-6">
      <label class="text-center w-100">{{$t('importe')}}</label>
      <input class="trans text-right" type="text" :value="importe" disabled />
    </div>   
  </div>
</template>

<script>
export default {
  name: "ins-otros-conceptos-comp",
  props: ["datos", "conceptos"],
  data: () => ({
    concepto: {
      id: null,
      cantidad: 0,
      importe: 0
    }
  }),
  computed: {
    importe: function() {
      return (this.concepto.cantidad * this.datos.importe).toFixed(2) + "€";
    }
  },
  methods: {
    emitirConcepto() {     
        const datos = {
          id: this.datos.id,
          cantidad: this.concepto.cantidad,
          importe: (this.concepto.cantidad * this.datos.importe).toFixed(2),
          nombre: this.datos.name
        };
        this.$emit("emitAddOtrosC", datos);
       
      
    }
  },
  mounted() {
    console.log(this.datos)
     if (this.conceptos.length > 0) {
          const tmpConcepto = this.conceptos.find(c => c.id === this.datos.id);
          console.log(tmpConcepto, !!tmpConcepto)
          if(!!tmpConcepto) {
            this.concepto.cantidad = parseInt(tmpConcepto.cantidad);
            
          } 
        }
  }
};
</script>

<style scoped>
input {
  height: 36px !important;
}
.trans {
  background-color: white;
  color: red;
  font-weight: bold;
  font-size: 1.2em;
}
.mi-input {
  font-weight: bold;
  font-size: 1.2em;
  color: blue;
}
input:focus {
  color: #ff0000;
}
</style>